import create from 'zustand';
import { Actions, actions } from './actions';
import { State, state } from './state';

export type RunningTradeStore = Actions & State;

export const useRunningTradeStore = create<RunningTradeStore>(
  (set, get, store, storeMutation) => ({
    ...actions(set, get, store, storeMutation),
    ...state,
  }),
);
